import { ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsUUID,
  IsBoolean,
  IsEnum,
  IsOptional,
  IsInt,
  Min,
  Max,
} from 'class-validator'
import { Type } from 'class-transformer'
import {
  OffsetPaginationQueryDto,
  PAGINATION_DEFAULTS_DTO as PAGINATION_DEFAULTS,
} from '@sphere/shared/domain'
import { ProficiencyLevel } from '../../../enums'

/** Limite plus élevée pour les concepts de programme (sélection dans formulaires) */
const PROGRAM_CONCEPTS_MAX_LIMIT = 500

export class ListProgramConceptsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    type: Number,
    description: "Nombre d'éléments par page",
    default: PAGINATION_DEFAULTS.LIMIT,
    minimum: 1,
    maximum: PROGRAM_CONCEPTS_MAX_LIMIT,
    example: 100,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(PROGRAM_CONCEPTS_MAX_LIMIT)
  override limit?: number = PAGINATION_DEFAULTS.LIMIT

  @ApiPropertyOptional({ type: 'string', description: 'Filter by program version ID' })
  @IsUUID()
  @IsOptional()
  programVersionId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by concept ID' })
  @IsUUID()
  @IsOptional()
  conceptId?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Show only core concepts' })
  @IsBoolean()
  @IsOptional()
  isCore?: boolean

  @ApiPropertyOptional({
    enum: ProficiencyLevel,
    description: 'Filter by expected level',
  })
  @IsEnum(ProficiencyLevel)
  @IsOptional()
  expectedLevel?: ProficiencyLevel
}
